module.exports = __webpack_public_path__ + "static/media/flu-vaccines-news.5ddb23b0.jpg";